export default {
  pre_op: "pre-op",
  post_op: "post-op",
  non_op: "no-op",
};
  